'use client'
import { cn } from '@/utilities/ui'
import React, { FC, useEffect, useRef } from 'react'
import Script from 'next/script'

interface AdBlockProps {
  title?: string
  className?: string
  adSlot?: string
  adClient?: string
  showPlaceholder?: boolean
}

export const AdBlock: FC<AdBlockProps> = ({
  title = 'Reklam Alanı',
  className,
  adClient = 'ca-pub-9752422442036358',
  adSlot = '4197240239',
  showPlaceholder = true,
}) => {
  const adRef = useRef<HTMLDivElement>(null)

  // Initialize ad after component mounts
  useEffect(() => {
    if (adRef.current && typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (error) {
        console.error('AdSense error:', error)
      }
    }
  }, [])

  return (
    <>
      <section
        className={cn(
          'container mx-auto flex flex-col items-center justify-center border border-stale-200 rounded-lg min-h-[128px] px-4',
          className,
        )}
      >
        {showPlaceholder && <div className="text-sm text-gray-400 mb-2">{title}</div>}

        <div ref={adRef} className="w-full">
          <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client={adClient}
            data-ad-slot={adSlot}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
      </section>
    </>
  )
}
